import '@angular/localize/init'
import { getWmLocale } from '@wm-front/core/locale'
import { loadTranslations } from '@angular/localize'
import { getTranslations, ParsedTranslationBundle } from '@locl/core'
import { registerLocaleData } from '@angular/common'
import localeEnGB from '@angular/common/locales/en-GB'
import localeFr from '@angular/common/locales/fr'
import localePtPT from '@angular/common/locales/pt-PT'
import localeZhHantHK from '@angular/common/locales/zh-Hant-HK'
import { environment } from './environments/environment'
import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'

if (environment.production) {
  enableProdMode()
}

/** Register the locales */
registerLocaleData(localeFr)
registerLocaleData(localeEnGB)
registerLocaleData(localePtPT)
registerLocaleData(localeZhHantHK)

const locale = getWmLocale()

getTranslations(`assets/i18n/${locale}.json`)
  .then((data: ParsedTranslationBundle) => {
    loadTranslations(data.translations as any)
  })
  .catch((err) => {
    console.error(`Unable to fetch translations`, err)
  })
  .then(async () => {
    return bootstrapApplication(
      (await import('./app/app.component')).AppComponent,
      appConfig
    )
  })
  .catch((err) => {
    console.error(err)
  })
